import styled from "styled-components";
import { devices } from "../../ExternFormEnrollment.styles";
import { BiInfoCircle } from "react-icons/bi";

export const Container = styled.div`
    margin-bottom: 30px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: var(--font-size-xlarge);

    @media ${devices.tablet} {
        font-size: var(--font-size-body);
    }
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  margin-top: 12px;
  @media ${devices.tablet} {
    gap: 16px;
    flex-direction: row;
  }
`;

export const ConsentHeadline = styled.h2`
    margin-bottom: 20px; 
    margin-top: 12px;
    font-weight: 500;
    font-size: var(--font-size-xlarge);

    @media ${devices.tablet} {
        font-size: var(--font-size-body);
    }
}
`;

export const ConsentContainer = styled.div` 
    margin-top: 40px;
`;

export const Consent = styled.p`
    margin-bottom: 8px;
    margin-top: 8px;
    font-size: 14px;
`;

export const ConsentTitle = styled.p`
    margin-bottom: 0px;
    padding-right: 8px;
    font-size: var(--font-size-xlarge);
    font-weight: 600;
    @media ${devices.tablet} {
        font-size: var(--font-size-body);
    }
`;

export const ConsentDescription = styled.p`
    margin-bottom: 4px;
    font-size: 14px;
    @media ${devices.tablet} {
        font-size: 13px;
    }
`;

export const InfoIconContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 12px;
    justify-content: space-between;
`;

export const InfoIcon = styled(BiInfoCircle)`
    font-size: 25px;
    cursor: pointer;
`;

export const ModelLink = styled.a`
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    @media ${devices.tablet} {
        font-size: 13px;
    }
`;

